var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFootermail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.392303 1.62237C2.96897 3.61419 7.49021 7.1184 8.81906 8.21102C8.99745 8.35849 9.18879 8.43346 9.38742 8.43346C9.58565 8.43346 9.77665 8.35919 9.95464 8.21242C11.2846 7.11873 15.8059 3.61419 18.3826 1.62237C18.543 1.4986 18.5675 1.28105 18.4376 1.12973C18.1373 0.780073 17.6897 0.57959 17.2099 0.57959H1.56491C1.08518 0.57959 0.637503 0.780074 0.337301 1.12977C0.207423 1.28105 0.231881 1.4986 0.392303 1.62237Z",
    fill: "#3AB100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5472 2.69979C18.4085 2.64088 18.2454 2.66143 18.1301 2.7514C15.2726 4.96247 11.6257 7.79662 10.4783 8.74037C9.83427 9.27099 8.94048 9.27099 8.29498 8.73966C7.07195 7.73383 2.97657 4.55595 0.643965 2.75136C0.527837 2.6614 0.364371 2.64155 0.226865 2.69975C0.0886267 2.75836 0 2.88457 0 3.02367V12.0019C0 12.7895 0.701644 13.43 1.56452 13.43H17.2096C18.0724 13.43 18.7741 12.7895 18.7741 12.0019V3.02367C18.7741 2.88457 18.6854 2.75802 18.5472 2.69979Z",
    fill: "#3AB100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootermail);
export default __webpack_public_path__ + "static/media/footermail.b4ee61d3a45715df334aaecc286326ec.svg";
export { ForwardRef as ReactComponent };